import React from 'react';
import styles from './Cover.module.css';

const Cover = () => {
  return (
    <section className={styles.cover}> 
     <div style={{
      position: 'relative', 
      overflow: 'hidden', 
      margin: 0, 
      paddingBottom: '0'
    }}>
      
      <video className={styles.video} autoPlay muted loop playsInline onError={(e) => console.error('Video error:', e)}>
        <source src="/intro.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div style={{
        position: 'absolute', 
        bottom: 0,  
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'white',
        padding: '4rem', 
        borderRadius: '1rem 1rem 0 0', 
        width: '60%', 
      }}>
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}> {/* Center the logo */}
          <img 
            src="/logo.png"  // Assuming logo.png is in the public folder
            alt="Logo"
            style={{ maxWidth: '100%' }} // Ensure logo scales down if needed
          />
        </div>

        <div style={{  
          position: 'relative', 
          overflow: 'visible' 
        }}>
          <h2 style={{ 
            position: 'absolute', 
            bottom: '-1.5em', // Adjust as needed to control overlap
            left: '50%', 
            transform: 'translateX(-50%)',
            color: '#438B4D',
            fontSize: 60,
            textAlign: 'center',

        fontFamily: 'NewZen-Bold',
          }}> 
            More than dating
          </h2>
        </div>
      </div>
    </div>
    </section>
  );
};

export default Cover;
